import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import { useAuth } from "../lib/auth";
import { Radar, Crosshair, ScanLine, Code2, LogOut, Palette, Target, KeyRound } from "lucide-react";

const mobileTabs = [
  { to: "/operator", end: true, label: "Radar", icon: Radar, testid: "mtab-lawsuit-radar" },
  { to: "/operator/geo-blitz", label: "Geo-Blitz", icon: Crosshair, testid: "mtab-geo-blitz" },
  { to: "/operator/auditor", label: "Auditor", icon: ScanLine, testid: "mtab-site-auditor" },
  { to: "/operator/deployments", label: "Shield", icon: Code2, testid: "mtab-script-deployment" },
  { to: "/operator/competitor-hunt", label: "Hunt", icon: Target, testid: "mtab-competitor-hunt" },
  { to: "/operator/brand", label: "Brand", icon: Palette, testid: "mtab-brand-settings" },
  { to: "/operator/account", label: "Account", icon: KeyRound, testid: "mtab-account-security" },
];

export default function DashboardLayout() {
  const { email, logout } = useAuth();
  return (
    <div className="min-h-screen flex bg-white">
      <Sidebar />

      <main className="flex-1 min-w-0 flex flex-col">
        {/* Mobile header */}
        <header className="md:hidden flex items-center justify-between px-4 py-3 bg-zinc-950 text-white border-b border-zinc-950 print:hidden">
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 border-2 border-white grid place-items-center text-xs font-black">A</div>
            <div className="font-display font-black tracking-tight">ADA INTERCEPTOR</div>
          </div>
          <button onClick={logout} className="text-xs font-bold uppercase" data-testid="mobile-logout-button">
            <LogOut className="w-4 h-4" />
          </button>
        </header>

        <div className="flex-1 min-w-0">
          <Outlet />
        </div>

        {/* Mobile bottom-nav */}
        <nav className="md:hidden sticky bottom-0 grid grid-cols-6 bg-zinc-950 text-white border-t border-zinc-800 print:hidden">
          {mobileTabs.map(({ to, end, label, icon: Icon, testid }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={testid}
              className={({ isActive }) =>
                `flex flex-col items-center gap-1 py-3 text-[10px] font-bold uppercase tracking-wider border-t-2 ${
                  isActive ? "border-blue-500 text-white" : "border-transparent text-zinc-400"
                }`
              }
            >
              <Icon className="w-4 h-4" />
              {label}
            </NavLink>
          ))}
        </nav>
      </main>
    </div>
  );
}

export function PageHeader({ eyebrow, title, description, actions, testid }) {
  return (
    <div className="px-4 md:px-8 pt-6 md:pt-10 pb-6 border-b border-zinc-200" data-testid={testid}>
      <div className="max-w-[1600px] mx-auto flex flex-col md:flex-row md:items-end md:justify-between gap-4">
        <div>
          {eyebrow && <div className="label-xs mb-2">{eyebrow}</div>}
          <h1 className="font-display text-3xl md:text-4xl font-black text-zinc-950 tracking-tighter">{title}</h1>
          {description && <p className="mt-2 text-sm md:text-base text-zinc-600 max-w-2xl">{description}</p>}
        </div>
        {actions && <div className="flex gap-2 flex-wrap">{actions}</div>}
      </div>
    </div>
  );
}
